import { useSite } from '../lib/SiteContentContext';

/**
 * Displays the Science Sorted horizontal wordmark with the
 * "Teacher & Examiner-led Tuition" tagline visually cropped out.
 *
 * Source image is 1651x501 - the wordmark occupies the top ~77%.
 * A wrapper with aspect-ratio 1651:388 + overflow-hidden clips the tagline.
 * Pass `className` with a Tailwind `h-*` utility (e.g. "h-16 md:h-24").
 */
export default function LogoImage({ className = '', alt = 'Science Sorted' }) {
  const { brand } = useSite();
  return (
    <div
      style={{ aspectRatio: '1651 / 320' }}
      className={`overflow-hidden inline-block ${className}`}
    >
      <img
        src={brand.logoUrl}
        alt={alt}
        className="w-full h-auto block select-none pointer-events-none"
        draggable={false}
      />
    </div>
  );
}
